import type { ComponentPropsWithoutRef, ReactNode } from 'react';

export type SectionSpacing = 'compact' | 'default' | 'large';

type SectionProps = {
  children: ReactNode;
  spacing?: SectionSpacing;
  tone?: 'page' | 'soft' | 'dark';
} & ComponentPropsWithoutRef<'section'>;

export function Section({
  children,
  className = '',
  spacing = 'default',
  tone = 'page',
  ...props
}: SectionProps) {
  return (
    <section
      className={`section section--${spacing} section--${tone} ${className}`.trim()}
      {...props}
    >
      {children}
    </section>
  );
}
